import styled from '@emotion/styled';
import { margin, tint } from 'polished';

const SocialButton = styled.div(
  ({ theme, pad }) => ({
    alignItems: 'center',
    backgroundColor: theme.color.warning,
    borderRadius: 20,
    color: theme.color.white,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    ...margin(null, '0.25em'),
    outline: 0,
    padding: pad ? '0.5em 1em' : '0.5em',
    transitionDuration: '0.2s',
    '&:active, &:hover': {
      backgroundColor: tint(0.7, theme.color.warning),
      transform: 'scale(1.1)'
    }
  }),
  ({ vibrant, theme, backgroundColor }) =>
    vibrant
      ? {
          backgroundColor: backgroundColor || theme.color.primary,
          color: 'white',
          '&:active, &:hover': {
            backgroundColor: tint(0.7, backgroundColor || theme.color.primary)
          }
        }
      : {}
);

export default SocialButton;
